import { IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/mmLogo_NoBackgroundFinal.png";
import "./Footer.css";

export const Footer = () : JSX.Element => {

    const navigate = useNavigate();

    return (
        <footer className="footer footer-bleed">
            <div className="footer-container">
                {/* Left Section */}
                <div className="footer-left">
                    <img
                        className="footer-logo"
                        src={Logo}
                        alt="Method Materials Logo"
                    />
                    <p className="footer-description">
                        Helping contractors increase profitability through group purchasing, business resources, and strategic partnerships.                    </p>
                    <div className="footer-social-icons">
                        <div className="social-icon" onClick={() => {}}>
                            <IconBrandFacebook size={20} color="white" onClick={()=> {window.location.assign('https://www.facebook.com/methodmaterials');}}/>
                        </div>
                        <div className="social-icon" onClick={() => {window.location.assign('https://www.instagram.com/method_materials_inc/');}}>
                            <IconBrandInstagram size={20} color="white" />
                        </div>
                        <div className="social-icon" onClick={() => {window.location.assign('https://www.linkedin.com/company/method-materials');}}>
                            <IconBrandLinkedin size={20} color="white" />
                        </div>
                    </div>
                </div>
                {/* Right Sections */}
                <div className="footer-links">
                    <div className="footer-column">
                        <h4 className="footer-heading">Menu</h4>
                        <ul>
                            <li onClick={() => {
                                navigate("/");
                                setTimeout(() => {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }, 100)
                            }}>Home</li>
                            <li onClick={() => {
                                navigate("/about");
                                setTimeout(() => {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }, 100)
                            }}>About</li>
                            <li onClick={() => {
                                navigate("/member-benefits");
                                setTimeout(() => {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }, 100)
                            }}>Member Benefits</li>
                            <li onClick={() => {
                                navigate("/contact");
                                setTimeout(() => {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }, 100)
                            }
                            }>Contact</li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="footer-bottom">
                    <p>© 2026 Method Materials. All rights reserved.</p>
                    <div className="footer-policies">
                        <span onClick={() => {
                            navigate("/privacy-policy");
                            setTimeout(() => {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }, 100)
                        }}>Privacy Policy</span>
                        <span onClick={() => {
                            navigate("/terms-of-service");
                            setTimeout(() => {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }, 100)
                        }}>Terms of Service</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};
